import {match, Pattern} from 'ts-pattern';

import {ASSISTANT_CHAT_URL_OVERRIDE_KEY} from './constants/ASSISTANT_CHAT_URL_OVERRIDE_KEY';
import {IS_PRODUCTION_BUILD} from './constants/IS_PRODUCTION_BUILD';
import {PROMPT_BRIDGE_ASSISTANT_CHAT_PATH} from './constants/PROMPT_BRIDGE_ASSISTANT_CHAT_PATH';
import {PROMPT_BRIDGE_BASE_URL} from './constants/PROMPT_BRIDGE_BASE_URL';

const LOOPBACK_HOSTNAMES = ['localhost', '127.0.0.1', '[::1]'];
const HTTP_PROTOCOLS = ['http:', 'https:'];

const derivePromptBridgeBaseUrl = (candidate: string): string | null => {
  try {
    const url = new URL(candidate);
    const isSafeOverride =
      LOOPBACK_HOSTNAMES.includes(url.hostname) &&
      HTTP_PROTOCOLS.includes(url.protocol) &&
      url.pathname.endsWith(PROMPT_BRIDGE_ASSISTANT_CHAT_PATH);

    return match(isSafeOverride)
      .with(true, () => {
        const basePath = url.pathname.slice(0, -PROMPT_BRIDGE_ASSISTANT_CHAT_PATH.length);
        return `${url.origin}${basePath}`;
      })
      .with(false, () => null)
      .exhaustive();
  } catch {
    return null;
  }
};

// No workspace-labelled host here: the gateway does not yet route /prompt-bridge/* on
// workspace-labelled hosts (404s); the backend resolves the workspace from the JWT instead.
export const resolvePromptBridgeBaseUrl = (): string =>
  match(IS_PRODUCTION_BUILD)
    .with(true, () => PROMPT_BRIDGE_BASE_URL)
    .with(false, () =>
      match(localStorage.getItem(ASSISTANT_CHAT_URL_OVERRIDE_KEY))
        .with(
          Pattern.string,
          (override) => derivePromptBridgeBaseUrl(override) ?? PROMPT_BRIDGE_BASE_URL
        )
        .with(null, () => PROMPT_BRIDGE_BASE_URL)
        .exhaustive()
    )
    .exhaustive();
